import { Component, Input, OnInit } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  RolloverPropertyTypeEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/rollover/rollover-property-type.enum';

@Component({
  selector: 'app-rollover-property-transferred-result',
  templateUrl: './rollover-property-transferred-result.component.html',
  styleUrls: ['./rollover-property-transferred-result.component.scss'],
  standalone: false,
})
export class RolloverPropertyTransferredResultComponent implements OnInit {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;
  @Input()
  propertyTransferredResults: RolloverPropertyTransferredResult;
  @Input()
  propertyTransferredOptions: RolloverPropertyTransferredOptions;

  isSectionPropertyTransferredCollapsed: boolean = false;

  propertyTypeEnum = RolloverPropertyTypeEnum;

  @Input()
  selectedBadge: string;

  ngOnInit() {
  }
}
